import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import { withStyles } from "@material-ui/core/styles";
import instance from "../../../store/actions/instance";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { withRouter } from "react-router-dom";
import {
  fetchBranch,
  refreshStorefrontOrderPassData,
  saveAddress,
  setBranchDeliveryCharge,
  setOrderPassData,
  updateMOV,
} from "../../../store/actions";
import ChangeDeliveryTypeDialog from "../SecondStep/ChangeDeliveryTypeDialog";
import { CircularProgress } from "@material-ui/core";
import { fetchTargetedDeliveryChargesForAreas } from "../../../store/actions/store";
import {
  getOrderPassDomain,
  getOrderPassSavedAreaNames,
  getSavedAddresses,
  hydrateOrderPassAddresses,
  isOrderPassPhoneVerified,
  normalizeOrderPassPhone,
} from "../../../Helpers/orderPass";
import {
  orderPassButtonStyle,
  orderPassIconButtonStyle,
  orderPassModalActionsStyle,
  orderPassModalContentStyle,
  orderPassModalPaperStyle,
  orderPassModalTitleStyle,
} from "../../../Helpers/orderPassUi";

const normalizeCountryName = (name) =>
  `${name || ""}`
    .replace(/[\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "")
    .trim()
    .toLowerCase();

const ColoredRadio = withStyles({
  root: {
    color: "#0099cc",
    "&$checked": {
      color: "#0099cc",
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

class Addresses extends Component {
  getAddresses = () =>
    getSavedAddresses(
      { user: this.props.auth.user, addresses: this.props.authAddresses },
      this.props.orderPassAddresses,
      this.props.settings,
    );

  state = {
    selectedAddress: this.getAddresses().find((a) => a.is_preferred)?.id,
    dialogOpen: false,
    deleteConfirmAddress: null,
    deletingConfirmedAddress: false,
    tempSelectedAddress: null,
    selectLoading: false,
    fetchingDeliveryCharges: false,
  };

  componentDidMount = async () => {
    if (
      this.props.settings?.enable_orderpass &&
      this.props.orderPassVerifiedPhone
    ) {
      const syncOrderPassInBackground = () => {
        this.props.refreshStorefrontOrderPassData();
      };

      if (typeof window !== "undefined" && window.requestIdleCallback) {
        window.requestIdleCallback(syncOrderPassInBackground, {
          timeout: 1500,
        });
      } else {
        window.setTimeout(syncOrderPassInBackground, 0);
      }
    }

    if (!this.props.fetchedDeliveryCharges) {
      this.setState({ fetchDeliveryCharges: true });
      const addresses = this.getAddresses();
      const selectedBranchDeliveryChargeId = this.props.branch?.bdc || null;
      const selectedDeliveryChargeId = (
        this.props.branchDeliveryCharges || []
      ).find((bdc) => bdc.id == selectedBranchDeliveryChargeId)?.delivery_charge;

      await this.props.fetchTargetedDeliveryChargesForAreas({
        countryCode: this.props.country_code,
        areaNames: getOrderPassSavedAreaNames(addresses),
        selectedBranchDeliveryChargeId,
        selectedDeliveryChargeId,
      });
      this.setState({ fetchDeliveryCharges: false });
    }
  };
  normalizeValue = (value) => `${value || ""}`.trim().toLowerCase();

  isCurrentCheckoutAddress = (address) => {
    const customerAddress = this.props.customerAddress;
    if (!customerAddress || customerAddress.selectedDeliveryType === 1) {
      return false;
    }

    if (
      customerAddress.orderPassAddressId &&
      address.orderPassAddressId &&
      customerAddress.orderPassAddressId === address.orderPassAddressId
    ) {
      return true;
    }

    return (
      this.normalizeValue(customerAddress.country) ===
        this.normalizeValue(address.country_id) &&
      this.normalizeValue(customerAddress.area) ===
        this.normalizeValue(address.area_id) &&
      this.normalizeValue(customerAddress.block) ===
        this.normalizeValue(
          address.country__name === "Qatar" ? address.zone : address.block,
        ) &&
      this.normalizeValue(customerAddress.street) ===
        this.normalizeValue(address.street) &&
      this.normalizeValue(customerAddress.building) ===
        this.normalizeValue(address.building) &&
      this.normalizeValue(customerAddress.avenue) ===
        this.normalizeValue(address.avenue) &&
      this.normalizeValue(customerAddress.floor) ===
        this.normalizeValue(address.floor) &&
      this.normalizeValue(customerAddress.apartment) ===
        this.normalizeValue(address.apartment) &&
      this.normalizeValue(customerAddress.additional) ===
        this.normalizeValue(address.additional)
    );
  };

  componentDidUpdate = () => {
    const addresses = this.getAddresses();
    const selectedCheckoutAddressID =
      addresses.find((address) => this.isCurrentCheckoutAddress(address))?.id ||
      null;
    const preferredAddressID = addresses.find((a) => a.is_preferred)?.id;
    const nextSelectedAddressID =
      selectedCheckoutAddressID || preferredAddressID;

    if (
      nextSelectedAddressID &&
      nextSelectedAddressID !== this.state.selectedAddress
    ) {
      this.setState({ selectedAddress: nextSelectedAddressID });
    }
  };
  renderAddressDetails = (address) => {
    const { language, settings } = this.props;
    const normalizedCountryName = normalizeCountryName(address.country__name);
    const isQatar = normalizedCountryName === "qatar";
    const isEgypt = normalizedCountryName === "egypt";
    const isBahrain = normalizedCountryName === "bahrain";
    const translations = {
      Building: language == "english" ? "Building" : "مبنى",
      avenue: language == "english" ? "avenue" : "جادة",
      apartment: language == "english" ? "apartment" : "شقة",
      paci: language == "english" ? "paci" : "الرقم الآلي",
      additional: language == "english" ? "additional" : "اضافي",
      floor: language == "english" ? "floor" : "الدور",
      block: language == "english"
        ? isQatar
          ? "Zone"
          : isEgypt
          ? "Area"
          : "Block"
        : isQatar
        ? "منطقة"
        : isEgypt
        ? "منطقة"
        : isBahrain
        ? "مجمع"
        : "قطعة",
      street: language == "english" ? "St." : "شارع",
    };
    const details = [];
    const block = isQatar ? address.zone : address.block;
    if (block) details.push(`${translations.block} ${block}`);
    if (address.street) details.push(`${translations.street} ${address.street}`);
    if (address.building)
      details.push(`${translations["Building"]} ${address.building}`);
    if (!isEgypt && address.avenue)
      details.push(`${translations["avenue"]} ${address.avenue}`);
    if (address.floor) details.push(`${translations["floor"]} ${address.floor}`);
    if (address.apartment)
      details.push(`${translations["apartment"]} ${address.apartment}`);
    if (!isEgypt && address.location_id)
      details.push(`${translations["paci"]} ${address.location_id}`);
    if (address.additional)
      details.push(`${translations["additional"]}: ${address.additional}`);
    return details.join(", ");
  };
  renderAddressTitle = (address) => {
    const { language } = this.props;
    return language == "english"
      ? address.area__name || address.area_name || address.name || ""
      : address.area__ar_name || address.area__name || address.area_name || "";
  };
  onChangeAddress = (id) => {
    this.setState({ selectedAddress: id });
    if (this.props.auth.user) this.makeAddressPreferred(id);
    else this.selectOrderPassAddress(id);
  };

  selectOrderPassAddress = async (id) => {
    const selectedAddress = this.getAddresses().find((address) => address.id === id);
    if (!selectedAddress?.checkoutAddress) return;

    this.setState({ selectLoading: true });
    this.props.switchAddress(
      selectedAddress,
      this.props.settings.is_branch_based_ordering,
    );

    if (this.props.settings.is_branch_based_ordering) {
      this.props.updateBranch(selectedAddress);
      this.props.setBranchDeliveryCharge({
        bdc: selectedAddress.branch_delivery_charge_id,
        branch: selectedAddress.branch_delivery_charge__branch__id,
        isPickup: false,
      });
      this.props.updateMOV(
        this.props.branchDeliveryCharges.find(
          (bd) => bd.id == selectedAddress.branch_delivery_charge_id,
        )?.minimum_order_value || 0,
      );
    }

    if (this.props.extraAction) this.props.extraAction();
    this.setState({ selectLoading: false });
    this.props.onClose();
  };

  makeAddressPreferred = async (id) => {
    try {
      const res = await instance.post("make_address_preferred/", {
        address_id: id,
      });
      if (res.data.success) {
        this.props.makeAddressPreferred(id);
        let tempAddress = this.props.authAddresses.find((a) => a.id === id);
        this.props.switchAddress(
          tempAddress,
          this.props.settings.is_branch_based_ordering
        );
        if (this.props.settings.is_branch_based_ordering) {
          this.props.updateBranch(tempAddress);
        }
        if (this.props.extraAction) this.props.extraAction();
        this.props.onClose();
      }
    } catch (e) {
      console.error(e);
    }
  };
  deleteAddress = async (adrs) => {
    if (adrs?.orderPass) {
      await this.deleteOrderPassAddress(adrs);
      return;
    }

    if (!this.props.auth.user) return;
    try {
      const res = await instance.post("delete_address/", {
        address_id: adrs.id,
      });
      if (res.data.success) {
        this.props.deleteAddress(adrs.id, res.data.new_preferred);
        if (adrs.is_preferred || this.props.authAddresses.length == 0) {
          this.setState({ selectedAddress: res.data.new_preferred });
          if (this.props.settings.is_branch_based_ordering) {
            const newPreferredAddressIsFromTheSameBranch =
              this.props.authAddresses.find(
                (adr) => adr.id === res.data.new_preferred
              )?.branch_delivery_charge__branch__id ===
              adrs.branch_delivery_charge__branch__id;
            if (
              !this.props.authAddresses.length ||
              !newPreferredAddressIsFromTheSameBranch
            ) {
              if (!newPreferredAddressIsFromTheSameBranch) {
                this.props.updateBranch(
                  this.props.authAddresses.find(
                    (adr) => adr.id === res.data.new_preferred
                  )
                );
              } else this.props.clearBranch();
              this.props.updateCustomer({
                addresses: [], // This will clear the current customer address
                deletingAddress: true,
              });
              this.props.useDispatch("CLEAR_STORE"); // Start the loading screen so that it transitions smoothly
              window.setTimeout(() => window.location.reload(), 100);
            } else {
              this.props.updateBranch(
                this.props.authAddresses.find(
                  (adr) => adr.id === res.data.new_preferred
                )
              );
              this.props.updateCustomer({
                addresses: this.props.authAddresses,
                deletingAddress: true,
              });
            }

            this.props.updateMOV(
              this.props.branchDeliveryCharges.find(
                (bd) =>
                  bd.id ==
                  this.props.authAddresses.find(
                    (adr) => adr.id === res.data.new_preferred
                  )?.branch_delivery_charge_id
              )?.minimum_order_value || 0
            );
          } else
            this.props.updateCustomer({
              addresses: this.props.authAddresses,
              deletingAddress: true,
            });
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  openDeleteAddressPrompt = (adrs) => {
    if (!adrs || this.isCurrentCheckoutAddress(adrs)) return;
    this.setState({ deleteConfirmAddress: adrs });
  };

  closeDeleteAddressPrompt = () => {
    if (this.state.deletingConfirmedAddress) return;
    this.setState({ deleteConfirmAddress: null });
  };

  confirmDeleteAddress = async () => {
    const adrs = this.state.deleteConfirmAddress;
    if (!adrs) return;

    this.setState({ deletingConfirmedAddress: true });
    await this.deleteAddress(adrs);
    this.setState({
      deleteConfirmAddress: null,
      deletingConfirmedAddress: false,
    });
  };

  getOrderPassHydrationContext = () => ({
    settings: this.props.settings,
    areas: this.props.areas,
    branchDeliveryCharges: this.props.branchDeliveryCharges,
    countries: this.props.countries,
  });

  deleteOrderPassAddress = async (adrs) => {
    if (!adrs || this.isCurrentCheckoutAddress(adrs)) return;
    if (!this.props.settings?.enable_orderpass) return;

    if (
      !isOrderPassPhoneVerified(
        this.props.customerContact,
        this.props.orderPassVerifiedPhone,
      ) ||
      !this.props.orderPassStorefrontToken
    ) {
      return;
    }

    const addressId = adrs.orderPassAddressId || adrs.id;
    const phone = normalizeOrderPassPhone(this.props.customerContact?.phone);
    if (!addressId || !phone) return;

    try {
      const response = await instance.delete(
        `/order_pass/storefront_addresses/${addressId}/`,
        {
          data: {
            number: phone,
            domain: getOrderPassDomain(this.props.settings, this.props.store),
            storefront_token: this.props.orderPassStorefrontToken,
          },
        },
      );

      if (!response.data?.success) return;

      this.props.setOrderPassData({
        phone,
        addresses: hydrateOrderPassAddresses(
          response.data?.account?.addresses || [],
          this.getOrderPassHydrationContext(),
        ),
        verifiedPhone: phone,
        linked: true,
        storefrontToken:
          response.data?.storefront_token || this.props.orderPassStorefrontToken,
      });
    } catch (error) {
      console.error(error);
    }
  };
  areaIsActive = (adrs) => {
    const { settings } = this.props;
    if (adrs.orderPass) return !!adrs.orderPassMatched;
    if (
      !(
        (settings.enable_delivery || settings.enable_delivery_select) &&
        !this.props.cart.pickup_only_items
      )
    )
      return false;

    if (settings.is_branch_based_ordering) {
      return (
        adrs.area__is_deleted == false &&
        adrs.area__delivery_charge__is_active &&
        adrs.area__delivery_charge__is_deleted == false &&
        adrs.branch_delivery_charge__is_active &&
        adrs.branch_delivery_charge__is_deleted == false &&
        adrs.branch_delivery_charge__branch__is_deleted == false
      );
    }
    return (
      adrs.area__is_deleted == false &&
      adrs.area__delivery_charge__is_active &&
      adrs.area__delivery_charge__is_deleted == false
    );
  };

  clearCartAndChangeBranch = (adrsID) => {
    const addresses = this.getAddresses();
    const selectedAddress = addresses.find((adrs) => adrs.id === adrsID);
    if (!selectedAddress) return;
    this.props.branch.loading = true;
    this.props.fetchBranch(
      "delivery",
      selectedAddress.branch_delivery_charge_id,
      this.props.cart.cart,
      this.props.applied_promo,
      this.props.history,
      null,
      null,
      selectedAddress.branch_delivery_charge__branch__id
    );
    this.props.setBranchDeliveryCharge({
      bdc: selectedAddress.branch_delivery_charge_id,
      branch: selectedAddress.branch_delivery_charge__branch__id,
      isPickup: false,
    });
  };

  onClickAddress = (adrs) => {
    const { settings, branch } = this.props;
    const BDC = this.props.branchDeliveryCharges;
    let totalCartLength =
      this.props.cart.cart.length + this.props.promo_items.length;

    if (this.areaIsActive(adrs)) {
      if (!settings.is_branch_based_ordering) this.onChangeAddress(adrs.id);
      else {
        if (
          branch.branch !== adrs.branch_delivery_charge__branch__id &&
          branch.branch != null &&
          totalCartLength > 0
        ) {
          this.setState({
            tempSelectedAddress: adrs.id,
            dialogOpen: true,
          });
        } else if (branch.branch === adrs.branch_delivery_charge__branch__id) {
          this.setState({ selectLoading: true });

          this.props.updateMOV(
            BDC.find((bd) => bd.id == adrs.branch_delivery_charge_id)
              .minimum_order_value || 0
          );
          this.onChangeAddress(adrs.id);
        } else {
          this.onChangeAddress(adrs.id);
          this.clearCartAndChangeBranch(adrs.id);
        }
      }
    }
  };

  editAddress = (adrs) => {
    if (!adrs || !this.areaIsActive(adrs)) return;

    this.props.switchAddress(
      adrs,
      this.props.settings.is_branch_based_ordering,
    );

    if (this.props.settings.is_branch_based_ordering) {
      this.props.updateBranch(adrs);
      if (adrs.branch_delivery_charge_id) {
        this.props.setBranchDeliveryCharge({
          bdc: adrs.branch_delivery_charge_id,
          branch: adrs.branch_delivery_charge__branch__id,
          isPickup: false,
        });
        this.props.updateMOV(
          this.props.branchDeliveryCharges.find(
            (bd) => bd.id == adrs.branch_delivery_charge_id,
          )?.minimum_order_value || 0,
        );
      }
    }

    this.props.onClose();
    this.props.history.push("/checkout/address", {
      prevPath: this.props.history.location.pathname,
      editingSavedAddress: true,
    });
  };

  startNewAddress = () => {
    const customerAddress = this.props.customerAddress || {};

    this.props.saveAddress({
      selectedDeliveryType: 0,
      selectedAddressType: 0,
      country: customerAddress.country || null,
      area: customerAddress.area || null,
      pickupArea: null,
      orderPassAddressId: null,
      gpsConfirmed: false,
      block: "",
      street: "",
      building: "",
      avenue: "",
      apartment: "",
      floor: "",
      additional: "",
      lat: null,
      lng: null,
      paci: "",
      home_picture: null,
    });
  };

  shouldUseOrderPassPickerModal = () =>
    this.props.settings?.enable_orderpass &&
    this.props.orderPassVerifiedPhone &&
    this.props.comingFrom !== "profile";

  hasPickupAvailable = () =>
    (this.props.settings?.enable_pickup ||
      this.props.settings?.enable_pickup_select) &&
    !this.props.settings?.is_menu &&
    (this.props.branches || []).some((branch) => branch.enable_pickup == true);

  getAddNewAddressRoute = () => ({
    pathname:
      this.props.comingFrom === "branchSelect"
        ? "/checkout/address"
        : "/select/branch",
    state: {
      prevPath: this.props.history.location.pathname,
      newAddress: true,
      previousAddress: this.props.customerAddress || null,
      previousBranch: this.props.branch || null,
    },
  });

  handleAddNewAddress = () => {
    this.startNewAddress();
    if (this.props.onAddNewAddress) this.props.onAddNewAddress();
    this.props.onClose();

    const route = this.getAddNewAddressRoute();
    this.props.history.push(route.pathname, route.state);
  };

  handlePickupInstead = () => {
    const previousAddress = this.props.customerAddress || null;
    const previousBranch = this.props.branch || null;

    this.props.saveAddress({
      selectedDeliveryType: 1,
      pickupArea: null,
      area: null,
      country: null,
      orderPassAddressId: null,
    });
    this.props.onClose();
    this.props.history.push("/select/branch", {
      type: 1,
      checkout: true,
      pickupOnly: true,
      prevPath: this.props.history.location.pathname,
      pickupFromAddressPicker: true,
      previousAddress,
      previousBranch,
    });
  };

  render() {
    const { language, open, settings, branch, themeColor, areas } = this.props;
    const { fetchDeliveryCharges } = this.state;
    const BDC = this.props.branchDeliveryCharges;
    let addresses = this.getAddresses();
    const currentCheckoutAddressID =
      addresses.find((address) => this.isCurrentCheckoutAddress(address))?.id ||
      null;
    const hasSelectedAddressInList = addresses.some(
      (address) => address.id === this.state.selectedAddress,
    );
    const effectiveSelectedAddressID = hasSelectedAddressInList
      ? this.state.selectedAddress
      : currentCheckoutAddressID;
    let totalCartLength =
      this.props.cart.cart.length + this.props.promo_items.length;
    const useOrderPassPickerModal = this.shouldUseOrderPassPickerModal();
    const hasPickupAvailable = this.hasPickupAvailable();
    if (this.props.comingFrom == "branchSelect" && this.props.bdcID) {
      if (settings.is_branch_based_ordering) {
        let tempBDC = BDC.find((bdc) => bdc.id === this.props.bdcID);
        if (tempBDC) {
          addresses = addresses.filter(
            (adrs) =>
              adrs.area__name === tempBDC.area ||
              adrs.area__ar_name === tempBDC.ar_area
          );
        }
      } else {
        let tempArea = areas.find((a) => a.id === this.props.bdcID);
        if (tempArea) {
          addresses = addresses.filter(
            (adrs) =>
              adrs.area__name === tempArea.name ||
              adrs.area__ar_name === tempArea.ar_name
          );
        }
      }
    }
    if (effectiveSelectedAddressID) {
      addresses = addresses
        .map((address, index) => ({ address, index }))
        .sort((left, right) => {
          const leftSelected = left.address.id === effectiveSelectedAddressID;
          const rightSelected = right.address.id === effectiveSelectedAddressID;
          if (leftSelected && !rightSelected) return -1;
          if (!leftSelected && rightSelected) return 1;
          return left.index - right.index;
        })
        .map(({ address }) => address);
    }
    const showOrderPassDeleteColumn =
      !useOrderPassPickerModal || addresses.length > 1;

    const pickerContent = (
      <>
        <Dialog
          open={!!this.state.deleteConfirmAddress}
          onClose={this.closeDeleteAddressPrompt}
          PaperProps={{
            style: orderPassModalPaperStyle({
              width: 360,
              maxWidth: "calc(100% - 32px)",
            }),
          }}
        >
          <DialogTitle
            disableTypography
            style={orderPassModalTitleStyle(language, {
              padding: "24px 24px 8px",
              borderBottom: "none",
              textAlign: language == "english" ? "left" : "right",
            })}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexDirection: "row",
                gap: 10,
                direction: language == "english" ? "ltr" : "rtl",
              }}
            >
              <span
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 0, 0, 0.08)",
                  color: "#ff3b30",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DeleteOutlineIcon />
              </span>
              <h2
                style={{
                  margin: 0,
                  fontFamily: language == "english" ? "Quicksand" : "Cairo",
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#222",
                  lineHeight: 1.35,
                  textAlign: language == "english" ? "left" : "right",
                }}
              >
                {language == "english"
                  ? "Delete saved address?"
                  : "حذف العنوان المحفوظ؟"}
              </h2>
            </div>
          </DialogTitle>
          <DialogContent
            style={orderPassModalContentStyle({
              padding: "8px 24px 20px",
              textAlign: language == "english" ? "left" : "right",
              direction: language == "english" ? "ltr" : "rtl",
            })}
          >
            <p
              style={{
                margin: "0 0 12px",
                color: "#666",
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                fontSize: 14,
                lineHeight: 1.6,
              }}
            >
              {language == "english"
                ? "This address will be removed from orderPass and will no longer appear in checkout."
                : "سيتم حذف هذا العنوان من orderPass ولن يظهر مرة أخرى في الدفع."}
            </p>
            {this.state.deleteConfirmAddress && (
              <div
                style={{
                  border: "1px solid #e5e5e5",
                  borderRadius: 6,
                  padding: "12px 14px",
                  backgroundColor: "#fafafa",
                }}
              >
                <p
                  className="bold"
                  style={{ margin: 0, color: "#222", fontSize: 13 }}
                >
                  {this.renderAddressTitle(this.state.deleteConfirmAddress)}
                </p>
                <p
                  className="bold"
                  style={{
                    margin: "4px 0 0",
                    color: "#777",
                    fontSize: 12.5,
                    lineHeight: 1.4,
                  }}
                >
                  {this.renderAddressDetails(this.state.deleteConfirmAddress)}
                </p>
              </div>
            )}
          </DialogContent>
          <DialogActions
            style={orderPassModalActionsStyle({
              padding: "0 24px 24px",
              borderTop: "none",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
              direction: language == "english" ? "ltr" : "rtl",
            })}
          >
            <Button
              variant="outlined"
              disabled={this.state.deletingConfirmedAddress}
              onClick={this.closeDeleteAddressPrompt}
              style={orderPassButtonStyle({ height: 44 })}
            >
              {language == "english" ? "Cancel" : "إلغاء"}
            </Button>
            <Button
              variant="contained"
              disabled={this.state.deletingConfirmedAddress}
              onClick={this.confirmDeleteAddress}
              style={orderPassButtonStyle({
                height: 44,
                color: "white",
                backgroundColor: "#ff3b30",
              })}
            >
              {this.state.deletingConfirmedAddress
                ? language == "english"
                  ? "Deleting..."
                  : "جارٍ الحذف..."
                : language == "english"
                  ? "Delete"
                  : "حذف"}
            </Button>
          </DialogActions>
        </Dialog>
        {settings.is_branch_based_ordering && this.state.dialogOpen && (
          <ChangeDeliveryTypeDialog
            yes={() => {
              this.clearCartAndChangeBranch(this.state.tempSelectedAddress);
              this.onChangeAddress(this.state.tempSelectedAddress);
            }}
            dialogOpen={this.state.dialogOpen}
            onClose={() => {
              this.setState({ dialogOpen: false });
            }}
          />
        )}
        <div
          style={{
            backgroundColor: "white",
            padding: useOrderPassPickerModal ? "4px 0" : 0,
          }}
        >
          {fetchDeliveryCharges ? (
            <div
              style={{
                width: "100%",
                minHeight: useOrderPassPickerModal ? 220 : 140,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: useOrderPassPickerModal ? "28px 0" : "24px 0",
                direction: language == "english" ? "ltr" : "rtl",
              }}
            >
              <div
                style={{
                  width: 92,
                  height: 92,
                  border: "1px solid rgba(0, 153, 204, 0.18)",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, rgba(0,153,204,0.08), rgba(0,153,204,0.02))",
                  boxShadow: "0 12px 28px rgba(0, 153, 204, 0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: 54,
                    height: 54,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                    boxShadow: "0 8px 18px rgba(0, 153, 204, 0.12)",
                  }}
                >
                  <CircularProgress
                    color="primary"
                    size={26}
                    thickness={4.5}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              {!useOrderPassPickerModal && (
                <h2
                  className={"mx-auto ".concat(
                    addresses.length
                      ? language == "english"
                        ? "text-left"
                        : "text-right"
                      : "text-center"
                  )}
                  style={{
                    width: "90%",
                    marginTop: 25,
                    fontFamily: language == "english" ? "Quicksand" : "Cairo",
                    fontSize: 16,
                  }}
                >
                  {addresses.length ? (
                    <>
                      {language == "english"
                        ? "Delivery address"
                        : "عنوان التوصيل"}
                    </>
                  ) : (
                    (settings.enable_delivery ||
                      settings.enable_delivery_select) && (
                      <>
                        {language == "english"
                          ? "You don't have saved addresses"
                          : "ليس لديك عناوين محفوظة!"}
                      </>
                    )
                  )}
                </h2>
              )}
              {!(
                settings.enable_delivery || settings.enable_delivery_select
              ) && (
                <p
                  className="bold"
                  style={{
                    color: "red",
                    paddingLeft: language == "english" && 16,
                    paddingRight: language == "arabic" && 16,

                    marginBottom: 10,
                  }}
                >
                  {language == "english"
                    ? "Sorry. We're not delivering at the moment"
                    : "عذرا. لا نقوم بالتوصيل حاليا"}
                </p>
              )}
              {!!addresses.length &&
                (settings.enable_delivery ||
                  settings.enable_delivery_select) && (
                  <List
                    dense
                    style={{
                      backgroundColor: "white",
                      padding: useOrderPassPickerModal ? "4px 0" : undefined,
                    }}
                  >
                    {addresses.map((adrs) => {
                      const labelId = `checkbox-list-secondary-label-${adrs.id}`;
                      const currentAddress =
                        effectiveSelectedAddressID == adrs.id &&
                        this.areaIsActive(adrs) &&
                        this.props.customerAddress?.selectedDeliveryType !== 1;
                      const canDeleteAddress =
                        !currentAddress &&
                        !this.isCurrentCheckoutAddress(adrs) &&
                        ((adrs.orderPass &&
                          !!this.props.orderPassStorefrontToken &&
                          isOrderPassPhoneVerified(
                            this.props.customerContact,
                            this.props.orderPassVerifiedPhone,
                          )) ||
                          (!adrs.orderPass && !!this.props.auth.user));
                      if (useOrderPassPickerModal) {
                        const addressIsActive = this.areaIsActive(adrs);
                        return (
                          <div
                            key={adrs.id}
                            role="button"
                            tabIndex={addressIsActive ? 0 : -1}
                            onClick={() => {
                              if (addressIsActive) this.onClickAddress(adrs);
                            }}
                            style={{
                              direction: "ltr",
                              display: "grid",
                              gridTemplateColumns:
                                showOrderPassDeleteColumn
                                  ? "44px minmax(0, 1fr) 44px 44px"
                                  : "minmax(0, 1fr) 44px 44px",
                              columnGap: 8,
                              alignItems: "center",
                              padding: "10px 0",
                              cursor: addressIsActive ? "pointer" : "default",
                              opacity: addressIsActive ? 1 : 0.55,
                            }}
                          >
                            {showOrderPassDeleteColumn && (
                              <IconButton
                                aria-label="delete"
                                disabled={!canDeleteAddress}
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  this.openDeleteAddressPrompt(adrs);
                                }}
                                style={orderPassIconButtonStyle({
                                  color: canDeleteAddress
                                    ? "#ff0000cc"
                                    : "#d8d8d8",
                                })}
                              >
                                <DeleteOutlineIcon fontSize="small" />
                              </IconButton>
                            )}
                            <div
                              style={{
                                minWidth: 0,
                                textAlign:
                                  language == "english" ? "left" : "right",
                                direction:
                                  language == "english" ? "ltr" : "rtl",
                              }}
                            >
                              {!addressIsActive && (
                                <p
                                  className="bold"
                                  style={{
                                    color: "red",
                                    margin: "0 0 6px",
                                    fontSize: 13,
                                  }}
                                >
                                  {language == "english"
                                    ? "Not available"
                                    : "غير متاح"}
                                </p>
                              )}
                              <p
                                className="bold"
                                style={{
                                  color: "#222",
                                  fontSize: 13.5,
                                  lineHeight: 1.3,
                                  margin: 0,
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {this.renderAddressTitle(adrs)}
                              </p>
                              <p
                                className="bold"
                                style={{
                                  color: "#777",
                                  fontSize: 12.5,
                                  lineHeight: 1.35,
                                  margin: "4px 0 0",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {this.renderAddressDetails(adrs)}
                              </p>
                            </div>
                            <IconButton
                              aria-label="edit"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.editAddress(adrs);
                              }}
                              disabled={!addressIsActive}
                              style={orderPassIconButtonStyle({
                                color: addressIsActive ? "#0099cc" : "#bdbdbd",
                              })}
                            >
                              <EditOutlinedIcon fontSize="small" />
                            </IconButton>
                            <ColoredRadio
                              checked={currentAddress}
                              onChange={() => this.onClickAddress(adrs)}
                              disabled={!addressIsActive}
                              style={orderPassIconButtonStyle({ padding: 6 })}
                            />
                          </div>
                        );
                      }
                      return (
                        <div
                          style={{
                            direction: language == "english" ? "ltr" : "rtl",
                          }}
                        >
                          {!this.areaIsActive(adrs) && (
                            <p
                              className="bold"
                              style={{
                                color: "red",
                                paddingLeft: language == "english" && 16,
                                paddingRight: language == "arabic" && 16,
                                textAlign:
                                  language == "english" ? "left" : "right",
                                position: "relative",
                                top: 8,
                                marginBottom: 0,
                              }}
                            >
                              {language == "english"
                                ? "Not available"
                                : "غير متاح"}
                            </p>
                          )}
                          <ListItem
                            key={adrs.id}
                            button
                            onClick={() => {
                              this.onClickAddress(adrs);
                            }}
                            disabled={!this.areaIsActive(adrs)}
                            style={{
                              alignItems: "flex-start",
                              paddingTop: useOrderPassPickerModal ? 10 : undefined,
                              paddingBottom: useOrderPassPickerModal
                                ? 10
                                : undefined,
                              paddingRight:
                                language == "english" && useOrderPassPickerModal
                                  ? 190
                                  : language == "english"
                                    ? 120
                                    : 16,
                              paddingLeft:
                                language == "arabic" && useOrderPassPickerModal
                                  ? 190
                                  : language == "english"
                                    ? 16
                                    : 120,
                            }}
                          >
                            <ListItemText
                              id={labelId}
                              primary={
                                <>
                                  <span className="bold">
                                    {this.renderAddressTitle(adrs)}
                                  </span>
                                </>
                              }
                              secondary={
                                <div style={{ paddingRight: 10 }}>
                                  <p className="bold m-0">
                                    {this.renderAddressDetails(adrs)}
                                  </p>
                                </div>
                              }
                              style={{
                                minHeight: 40,
                                maxWidth: "100%",
                                margin: 0,
                                textAlign:
                                  language == "english" ? "left" : "right",
                              }}
                            />
                            <ListItemSecondaryAction
                              style={{
                                left: language == "arabic" ? 16 : "unset",
                                right: language == "english" ? 16 : "unset",
                                display: "flex",
                                alignItems: "center",
                                gap: useOrderPassPickerModal ? 8 : 0,
                                top: useOrderPassPickerModal ? 14 : undefined,
                                transform: useOrderPassPickerModal
                                  ? "none"
                                  : undefined,
                              }}
                            >
                              <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  this.editAddress(adrs);
                                }}
                                disabled={!this.areaIsActive(adrs)}
                                style={{
                                  minWidth: useOrderPassPickerModal ? 62 : 78,
                                  textTransform: "none",
                                  marginLeft:
                                    language == "english" || useOrderPassPickerModal
                                      ? 0
                                      : 8,
                                  marginRight:
                                    language == "english" && !useOrderPassPickerModal
                                      ? 8
                                      : 0,
                                  paddingLeft: useOrderPassPickerModal ? 8 : undefined,
                                  paddingRight: useOrderPassPickerModal ? 8 : undefined,
                                }}
                                startIcon={
                                  language == "english" ? (
                                    <EditOutlinedIcon fontSize="small" />
                                  ) : null
                                }
                                endIcon={
                                  language == "arabic" ? (
                                    <EditOutlinedIcon fontSize="small" />
                                  ) : null
                                }
                              >
                                {language == "english" ? "Edit" : "تعديل"}
                              </Button>
                              <ColoredRadio
                                checked={currentAddress}
                                onChange={() => {
                                  this.onClickAddress(adrs);
                                }}
                                disabled={!this.areaIsActive(adrs)}
                              />
                              {canDeleteAddress && (
                                <DeleteOutlineIcon
                                  style={{
                                    color: "#ff0000cc",
                                    marginLeft:
                                      language == "english" && !useOrderPassPickerModal
                                        ? 5
                                        : 0,
                                    marginRight:
                                      language == "arabic" && !useOrderPassPickerModal
                                        ? 5
                                        : 0,
                                    cursor: "pointer",
                                    flexShrink: 0,
                                  }}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    this.openDeleteAddressPrompt(adrs);
                                  }}
                                />
                              )}
                            </ListItemSecondaryAction>
                          </ListItem>
                        </div>
                      );
                    })}
                  </List>
                )}

              {!!this.props.cart.cart.length &&
                !useOrderPassPickerModal &&
                (settings.enable_delivery || settings.enable_delivery_select) &&
                this.props.comingFrom !== "profile" && (
                  <Link
                    to={this.getAddNewAddressRoute()}
                    onClick={() => {
                      this.startNewAddress();
                      if (this.props.onAddNewAddress)
                        this.props.onAddNewAddress();
                      this.props.onClose();
                    }}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{
                        width: "97%",
                        marginBottom: 8,
                        marginTop: 10,
                        fontSize: "1rem",
                        boxShadow: "none",
                        textTransform: "none",
                      }}
                      dir={language == "english" ? "ltr" : "rtl"}
                      endIcon={language == "english" && <AddIcon />}
                      startIcon={
                        language == "arabic" && <AddIcon className="ml-2" />
                      }
                    >
                      {language == "english"
                        ? "Add a new address"
                        : "اضافة عنوان جديد"}
                    </Button>
                  </Link>
                )}

              {!useOrderPassPickerModal && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.props.onClose()}
                  style={{
                    width: "97%",
                    marginBottom: 8,
                    height: 45,
                    fontSize: "1rem",
                    marginTop: 15,
                    boxShadow: "none",
                    textTransform: "none",
                  }}
                  dir={language == "english" ? "ltr" : "rtl"}
                >
                  {this.state.selectLoading ? (
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  ) : (
                    <>
                      {this.props.backText ||
                        (language == "english" ? "Back" : "الرجوع")}
                    </>
                  )}
                </Button>
              )}
            </>
          )}
        </div>
      </>
    );

    if (useOrderPassPickerModal) {
      return (
        <Dialog
          open={open}
          onClose={() => this.props.onClose()}
          aria-labelledby="orderpass-address-picker-title"
          PaperProps={{
            style: orderPassModalPaperStyle({
              width: 420,
              maxWidth: "calc(100% - 24px)",
              maxHeight: "calc(100vh - 48px)",
            }),
          }}
        >
          <DialogTitle
            id="orderpass-address-picker-title"
            disableTypography
            style={orderPassModalTitleStyle(language, {
              padding:
                language == "english"
                  ? "24px 56px 24px 24px"
                  : "24px 24px 24px 56px",
              position: "relative",
              textAlign: language == "english" ? "left" : "right",
            })}
          >
            <h2
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                fontSize: 20,
                fontWeight: 500,
                margin: 0,
              }}
            >
              {language == "english"
                ? "Choose a saved address"
                : "اختر عنوانا محفوظا"}
            </h2>
            <IconButton
              aria-label={language == "english" ? "Close" : "اغلاق"}
              onClick={() => this.props.onClose()}
              style={{
                position: "absolute",
                top: 8,
                right: language == "english" ? 8 : "unset",
                left: language == "arabic" ? 8 : "unset",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            style={orderPassModalContentStyle({
              maxHeight: "min(56vh, 520px)",
              overflowY: "auto",
            })}
          >
            {pickerContent}
          </DialogContent>
          <DialogActions
            style={orderPassModalActionsStyle({
              display: "block",
            })}
          >
            {(settings.enable_delivery || settings.enable_delivery_select) && (
              <Button
                variant="outlined"
                color="primary"
                onClick={this.handleAddNewAddress}
                style={orderPassButtonStyle({
                  width: "100%",
                  marginBottom: hasPickupAvailable ? 12 : 0,
                })}
                dir={language == "english" ? "ltr" : "rtl"}
                endIcon={language == "english" && <AddIcon />}
                startIcon={language == "arabic" && <AddIcon className="ml-2" />}
              >
                {language == "english"
                  ? "Add a new address"
                  : "اضافة عنوان جديد"}
              </Button>
            )}
            {hasPickupAvailable && (
              <Button
                variant="text"
                color="primary"
                onClick={this.handlePickupInstead}
                style={orderPassButtonStyle({
                  width: "100%",
                  margin: 0,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                })}
              >
                {language == "english"
                  ? "Pick up instead"
                  : "الاستلام من الفرع بدلا من ذلك"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      );
    }

    return (
      <Drawer
        anchor="bottom"
        classes={{
          paperAnchorBottom: language == "arabic" ? "left-auto" : "",
        }}
        open={open}
        onClose={() => this.props.onClose()}
        PaperProps={{
          style: {
            minHeight: 100,
            height: "auto",
            width: "100%",
          },
          className: "text-center",
        }}
        onBackdropClick={() => this.props.onClose()}
      >
        {pickerContent}
      </Drawer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,

    settings: state.store.store.settings,
    authAddresses: state.auth.addresses,
    auth: state.auth,
    orderPassAddresses: state.customers.orderPassAddresses || [],
    orderPassVerifiedPhone: state.customers.orderPassVerifiedPhone,
    orderPassStorefrontToken: state.customers.orderPassStorefrontToken,
    customerContact: state.customers.customerContact,
    cart: state.cart,
    branch: state.branch,
    applied_promo: state.cart.promos,
    branchDeliveryCharges: state.store.store.branch_delivery_charges,
    branches: state.store.store.branches || [],
    promo_items: state.cart.promo_items,
    customerAddress: state.customers.address,
    themeColor: state.store.store.settings.dark || "#0099cc",
    areas: state.store.store.areas,
    country_code: state.store.store.country_code,
    fetchedDeliveryCharges: state.store.fetchedDeliveryCharges,
    countries: state.store.store.all_countries || state.store.store.countries,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchAddress: (adrs, isBranchBased) =>
      dispatch({
        type: "SWITCH_ADDRESS",
        payload: { address: adrs, isBranchBased: isBranchBased },
      }),
    saveAddress: (address) => dispatch(saveAddress(address)),
    refreshStorefrontOrderPassData: () =>
      dispatch(refreshStorefrontOrderPassData()),
    setOrderPassData: (data) => dispatch(setOrderPassData(data)),
    makeAddressPreferred: (id) =>
      dispatch({ type: "MAKE_ADDRESS_PREFERRED", payload: id }),
    updateCustomer: (data) =>
      dispatch({ type: "UPDATE_CUSTOMER", payload: data }),
    deleteAddress: (id, new_preferred) =>
      dispatch({ type: "DELETE_ADDRESS", payload: { id, new_preferred } }),
    updateBranch: (adrs) => dispatch({ type: "UPDATE_BRANCH", payload: adrs }),
    fetchBranch: (
      type,
      bdc_id,
      cart,
      promo,
      history,
      forceCurrency,
      QRValid,
      branchID
    ) =>
      dispatch(
        fetchBranch(type, bdc_id, cart, promo, history, null, null, branchID)
      ),
    setBranchDeliveryCharge: (bdc_obj) =>
      dispatch(setBranchDeliveryCharge(bdc_obj)),
    updateMOV: (mov) => dispatch(updateMOV(mov)),
    clearBranch: () => dispatch({ type: "CLEAR_BRANCH" }),
    useDispatch: (type) => dispatch({ type: type }),
    fetchTargetedDeliveryChargesForAreas: (payload) =>
      dispatch(fetchTargetedDeliveryChargesForAreas(payload)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Addresses)
);
